import React from 'react';

const Content = ({ children }: any) => <div className='content'>{children}</div>

export default Content;